import * as React from 'react'
import {Field, reduxForm} from 'redux-form'
import { validateFirstPage } from './validate'
import renderField from './Form'
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';

const WizardFormFirstPage = props => {
  const {handleSubmit} = props
  return (
    <div>
      <Card>
        <CardContent style={{padding: 50}}>
          <div style={{display: 'flex', justifyContent: "space-between", marginBottom: 20}}>
            <Field style={{width: '48%'}} name="name" type="text" component={renderField} label="Charity Name" />
            <Field style={{width: '48%'}} type="text" component={renderField} name="charityId" label="Charity ID" />
          </div>
          <div style={{marginBottom: 10}}>
            <Field style={{width:'100%'}} type="textarea" component={renderField} name="description" label="Short description of what you do." />
          </div>
          <div style={{paddingTop: 20}}>
            <Button  style={{background: '#209cee',color:'#fff'}} size="large" onClick={handleSubmit}>
              Next
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}

export default reduxForm({
  form: 'wizard', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  validate: validateFirstPage
})(WizardFormFirstPage)
